<template>
    <div class="payment__form">
        <form
            v-if="state.currentView === 'BANK_INIT_VIEW' && state.processing != true"
            @submit.prevent="step2"
        >
            <div v-if="state.currency === 'ZAR'">
                <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                    {{ $t("bank.init.select")}}
                </p>
                <primary-select
                    :title="$t('bank.input.bank')"
                    :description-text="$t('bank.select.description')"
                    @value-change="sa_bank = $event"
                    :options="state.sa_banks"
                    :defaultValue="
                        getValueFromPath(state, 'inputs.sa_bank.value') || null
                    "
                    inputName="bank"
                />
                <PrimaryButton
                    :content="
                        [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                            .filter(Boolean)
                            .join(' ')
                    "
                    :disabled="sa_bank == '' || sa_bank == null ? true : false"
                    type="submit"
                />
            </div>
            <div v-else>
                <p
                    v-if="state.currency !== 'NGN'"
                    class="container__col-md-12 container__col-sm-12 payment__instruction"
                >
                    {{ $t("bank.title.description")}}
                </p>
                <!-- <p
                v-else-if="state.currency === 'NGN'"
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            >
                Please select your bank to begin payment
            </p> -->
                <p
                    v-else
                    class="container__col-md-12 container__col-sm-12 payment__instruction"
                >
                    {{ $t("bank.init.description")}}
                </p>
                <primary-select
                    :title="$t('bank.input.bank')"
                    v-if="getValueFromPath(state, 'inputs.bank') || false"
                    :description-text="$t('ui.input.choose')"
                    inputName="bank"
                    :isRequired="getValueFromPath(state, 'inputs.bank.required') || true"
                    @value-change="bank = $event"
                    :options="state.banks"
                />
                <primary-input
                    :title="$t('bank.input.account')"
                    :number-only="true"
                    v-if="getValueFromPath(state, 'inputs.account_number') || false"
                    class="container__col-md-12 container__col-sm-12"
                    inputName="account_number"
                    :isRequired="
                        getValueFromPath(state, 'inputs.account_number.required') || true
                    "
                    type="tel"
                    prefix-image="account-number"
                    placeholder="0123456789"
                    @value-change="accountNumber = $event"
                />
                <primary-input
                    :title="$t('bank.input.phone')"
                    v-if="getValueFromPath(state, 'inputs.account_phone') || false"
                    class="container__col-md-12 container__col-sm-12"
                    inputName="account_phone"
                    :isRequired="
                        getValueFromPath(state, 'inputs.account_phone.required') || true
                    "
                    :defaultValue="
                        getValueFromPath(state, 'inputs.account_phone.value') || null
                    "
                    type="tel"
                    :number-only="true"
                    prefix-image="smart-phone"
                    placeholder="0800000000"
                    @value-change="telephone = $event"
                />
                <primary-input
                    title="BVN"
                    v-if="getValueFromPath(state, 'inputs.account_bvn') || false"
                    class="container__col-md-12 container__col-sm-12"
                    inputName="account_bvn"
                    :isRequired="
                        getValueFromPath(state, 'inputs.account_bvn.required') || true
                    "
                    :defaultValue="
                        getValueFromPath(state, 'inputs.account_bvn.value') || null
                    "
                    type="tel"
                    :number-only="true"
                    prefix-image="password"
                    placeholder="00000000000"
                    @value-change="bvn = $event"
                />
                <primary-input
                    :title="$t('bank.input.dob')"
                    v-if="getValueFromPath(state, 'inputs.account_dob') || false"
                    class="container__col-md-12 container__col-sm-12"
                    :isRequired="
                        getValueFromPath(state, 'inputs.account_dob.required') || true
                    "
                    type="date"
                    inputName="account_dob"
                    prefix-image="credit-card"
                    placeholder="DD/MM/YYYY"
                    @value-change="dob = $event"
                />
                <primary-input
                    :title="$t('bank.input.otp')"
                    v-if="getValueFromPath(state, 'inputs.account_otp.required') || false"
                    class="container__col-md-12 container__col-sm-12"
                    prefix-image="padlock"
                    placeholder="123456"
                    type="tel"
                    :isRequired="getValueFromPath(state, 'inputs.account_otp.required') || true"
                    @value-change="otp = $event"
                    inputName="otp"
                    :number-only="true"
                />
                <div v-if="getValueFromPath(state, 'inputs.account_otp.required') || false" class="container--row container__col-md-12 container__col-sm-12">
                    <p class="otp-instruction">Dial  <a :href="`tel://*822*999*0# `" rel="nofollow">*822*999*0#</a> on your mobile number to get OTP.</p>
                </div>
                <primary-input
                    :title="$t('bank.input.address')"
                    @value-change="address = $event"
                    :isRequired="getValueFromPath(state, 'inputs.address.required') || true"
                    v-if="getValueFromPath(state, 'inputs.address') || false"
                    inputName="address"
                    class="container__col-md-12 container__col-sm-12"
                    prefix-image="location"
                    placeholder="20 Saltlake Edorado"
                    :postfix-image="false"
                />
                <div class="container--row">
                    <div class="container__col-md-8 container__col-sm-8">
                        <primary-input
                            :title="$t('bank.input.city')"
                            @value-change="city = $event"
                            :date="false"
                            inputName="city"
                            v-if="getValueFromPath(state, 'inputs.city') || false"
                            :isRequired="
                                getValueFromPath(state, 'inputs.city.required') || true
                            "
                            class="container__col-md-12 container__col-sm-12"
                            prefix-image="building"
                            placeholder="Livingson"
                        />
                    </div>
                    <div class="container__col-md-4 container__col-sm-4">
                        <primary-input
                            :title="$t('bank.input.postarea')"
                            :total-characters="2"
                            @value-change="userState = $event"
                            inputName="state"
                            v-if="getValueFromPath(state, 'inputs.state') || false"
                            :isRequired="
                                getValueFromPath(state, 'inputs.state.required') || true
                            "
                            class="container__col-md-12 container__col-sm-12"
                            prefix-image="state"
                            placeholder="CA"
                        />
                    </div>
                </div>
                <div class="container__col-md-8 container__col-sm-8">
                    <primary-input
                        :title="$t('bank.input.postcode')"
                        @value-change="zip = $event"
                        :date="false"
                        inputName="zip"
                        type="tel"
                        v-if="getValueFromPath(state, 'inputs.postal_code') || false"
                        :isRequired="
                            getValueFromPath(state, 'inputs.postal_code.required') || true
                        "
                        class="container__col-md-12 container__col-sm-12"
                        prefix-image="zip-code"
                        placeholder="928302"
                    />
                </div>
                <PrimaryButton
                    type="submit"
                    :content="
                        [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                            .filter(Boolean)
                            .join(' ')
                    "
                    :disabled="hasCompletedFields === false"
                />
            </div>
        </form>
        <form
            v-else-if="
                state.currentView == 'BANK_OTP_VIEW' && state.processing !== true
            "
            @submit.prevent="submitOtp"
        >
            <p
                v-html="instructions"
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            ></p>
            <primary-input
                :title="$t('bank.otp.pin')"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="smart-phone"
                placeholder="123456"
                type="tel"
                :isRequired="getValueFromPath(state, 'inputs.otp.required') || true"
                @value-change="otp = $event"
                inputName="otp"
                :number-only="true"
            />
            <PrimaryButton :content="$t('bank.otp.confirm')" type="submit" />
            <div class="container--row container__col-md-12 container__col-sm-12 another-saved">
                <button
                    :disabled="!state.canResendOtp"
                    type="button"
                    aria-label="resend OTP"
                    class="payment__another"
                    role="button"
                    aria-pressed="false"
                    @click="resendOtp"
                >
                    {{ $t("bank.otp.resend") }}
                </button>
            </div>
        </form>
        <template
            v-else-if="
                state.currentView == 'REDIRECT_VIEW' && state.processing != true
            "
        >
            <div class="redirect-wrapper">
                <div class="redirect-icon--arrow">
                    <svg width="33" height="27" viewBox="0 0 33 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.1799 3.13007L18.5799 7.10007L24.7999 6.47007L13.2599 20.5301L4.15988 13.1301L1.62988 16.2201L13.8299 26.1301L27.9799 8.89007L28.6199 15.2501L32.5999 14.8501L31.2799 1.82007L18.1799 3.13007Z" fill="#FFCA7D"/>
                        <path d="M17.0998 1.51996L17.4998 5.47996L23.7098 4.85996L12.1798 18.91L3.0898 11.52L0.549805 14.61L12.7498 24.52L26.8998 7.27996L27.5398 13.64L31.5198 13.24L30.1998 0.209961L17.0998 1.51996Z" fill="black"/>
                        <path d="M0.549805 14.61L1.6298 16.22L13.8298 26.13L12.7498 24.52L0.549805 14.61Z" fill="#703E00"/>
                        <path d="M17.5 5.47998L18.58 7.09999L22.18 6.72998L23.71 4.85999L17.5 5.47998Z" fill="#703E00"/>
                        <path d="M27.54 13.64L28.62 15.25L32.6 14.85L31.52 13.24L27.54 13.64Z" fill="#FFCA7D"/>
                        <path d="M30.1997 0.209961L31.2797 1.81996L32.5997 14.85L31.5197 13.24L30.1997 0.209961Z" fill="#703E00"/>
                    </svg>
                </div>
            </div>
            <p class="container__col-md-12 container__col-sm-12 payment__instruction" v-if="state.currency == 'EUR' || state.currency == 'GBP'">
                <span>{{ $t("bank.redirect.instruction")}}</span>
                <br/>
                <br/>
                <span>{{$t("bank.redirect.expiry.a")}}</span>
                <span class="payment__instruction--duration"><b> {{$t("bank.redirect.duration")}} </b></span>
                <span>{{$t("bank.redirect.expiry.b")}}.</span>
            </p>
            <p class="container__col-md-12 container__col-sm-12 payment__instruction" v-else>
                {{ $t("bank.redirect.instruction")}}
            </p>
            <PrimaryButton :content="$t('ui.redirect.btn')" @click="Next" />
        </template>
        <template v-else-if="state.currentView == 'CONFIRMING_VIEW' && state.processing != true">
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{ $t("mm.confirming")}}
            </p>
            <div class="center">
                <div class="loader-icon"></div>
            </div>
        </template> 
    </div>
</template>

<script>
import { loadAnimation } from "lottie-web";
import { ref, watch, computed, onBeforeUnmount, onUpdated } from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath, getCodeFromString, autoInitialize } from "@/support/helpers";

import loading from "@/assets/lottie/loading";
import PrimarySelect from "@/components/form/base-select";
import PrimaryButton from "@/components/form/base-button";
import PrimaryInput from "@/components/form/base-input";
export default {
    name: "BankPayment",
    components: {
        PrimaryInput,
        PrimaryButton,
        PrimarySelect,
    },
    setup() {
        const store = injectStore();
        const bank = ref("");
        const sa_bank = ref("");
        const checkoutData = ref(store.getState());
        const transactionSuccessful = ref(false);
        const showAccount = ref(false);
        const showCopied = ref(false);
        const time = ref(null);
        const otp = ref("");
        const dob = ref("");
        const bvn = ref("");
        const address = ref("");
        const city = ref("");
        const userState = ref("");
        const zip = ref("");
        const telephone = ref(
            getValueFromPath(
                checkoutData.value,
                "view.context.inputs.account_phone.value",
            ) || null,
        );
        const accountNumber = ref(
            getValueFromPath(
                checkoutData.value,
                "view.context.inputs.account_number.value",
            ) || null,
        );
        const hasCompletedFields = computed(() => {
            let completed = false;
            if (["ZAR", "NGN", "EUR", "GBP"].includes(checkoutData.value.currency.current)) {
                completed = true;
            }
            return completed;
        });
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });
        watch(bank, (newVal, OldVal) => {
            if (newVal !== "" && OldVal !== null && newVal !== OldVal) {
                const data = { bank: newVal };
                checkoutData.value.view.context.$actions.update(data);
            }
        });
        watch(sa_bank, (newVal, OldVal) => {
            if (newVal !== OldVal) {
                const data = { sa_bank: newVal };
                checkoutData.value.view.context.$actions.update(data);
            }
        });
        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        const timer = computed(() => {
            let time = "";
            if (checkoutData.value.view.context.timerCurrent) {
                let duration = checkoutData.value.view.context.timerCurrent.time;
                let minutes = Math.floor(duration / 60);
                let seconds = duration % 60;
                time = `expires in ${minutes}mins ${seconds}secs`;
            }
            return time;
        });
        function submitOtp() {
            checkoutData.value.view.context.$actions.update({ otp: otp.value });
            Next();
        }
        function resendOtp() {
            checkoutData.value.view.context.resendOTP();
        }
        function step2() {
            let data;
            if (checkoutData.value.currency.current !== "NGN") {
                data = {
                    address: address.value || "",
                    state: userState.value,
                    city: city.value,
                    postal_code: zip.value,
                };
            }
            else {
                let date = dob.value.split("-").reverse().join("");
                data = {
                    account_number: accountNumber.value,
                    account_phone: telephone.value,
                    account_dob: date,
                    account_bvn: bvn.value,
                    account_otp: otp.value,
                };
            }

            checkoutData.value.view.context.$actions.update(data);
            sa_bank.value = null;
            Next();
        }
        function loadLottie() {
            loadAnimation({
                container: time.value,
                renderer: "svg",
                loop: true,
                autoplay: true,
                animationData: loading,
                rendererSettings: {
                    progressiveLoad: true,
                    hideOnTransparent: true,
                },
            });
        }
        watch(checkoutData, (val) => {
            if ( val.view != undefined &&
                val.view.current == "BANK_DETAILS_VIEW" &&
        checkoutData.value.processing != true
            ) {
                Next();
            }
        });

        // This works now => AutoInitialize using the helpers auto-initialise methods
        /**
         * ToDo:
         * Fix view to show error when amount is less than 200
         * after new checkout runtime!
         */

        const autoInitializePayment = autoInitialize("BANK_INIT_VIEW");

        const bankPaymentConditions = (checkoutData) => (["ZAR", "NGN", "EUR", "GBP"].includes(checkoutData.value.currency.current));

        onUpdated(() =>  {
            if(checkoutData.value.currency.current !== "ZAR"){
                autoInitializePayment(checkoutData, Next, bankPaymentConditions);
            } 
        });
        
        if (
            checkoutData.value.processing != true &&
            checkoutData.value.view != undefined &&
            checkoutData.value.view.current == "BANK_DETAILS_VIEW"
        ) {
            loadLottie();
        }
        const instructions = computed(() => {
            const instruction = getCodeFromString(
                checkoutData.value.view.context.instruction,
            );
            return instruction;
        });

        onBeforeUnmount(() => {
            if (checkoutData.value.view.current == "REDIRECT_VIEW" && checkoutData.value.currency.current === "ZAR") {
                checkoutData.value.view.context.resetView();
            }
            subscription();
        });
        return {
            state: mapState({
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
                amount: (state) => getValueFromPath(state, "amount") || null,
                processing: (state) => getValueFromPath(state, "processing") || false,
                error: (state) => getValueFromPath(state, "error") || null,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
                banks: (state) =>
                    getValueFromPath(state, "view.context.inputs.bank.options") || [],
                sa_banks: (state) =>
                    getValueFromPath(state, "view.context.inputs.sa_bank.options") || [],
                bankDetails: (state) =>
                    getValueFromPath(state, "view.context.details") || {},
                instructions: (state) =>
                    getValueFromPath(state, "view.context.instruction") || null,
                inputs: (state) => getValueFromPath(state, "view.context.inputs") || {},
                canResendOtp: (state) =>
                    getValueFromPath(state, "view.context.canResendOTP") || false,
            }),
            checkoutData,
            bank,
            otp,
            dob,
            bvn,
            sa_bank,
            showAccount,
            telephone,
            accountNumber,
            instructions,
            showCopied,
            getValueFromPath,
            transactionSuccessful,
            city,
            userState,
            zip,
            address,
            hasCompletedFields,
            step2,
            resendOtp,
            submitOtp,
            timer,
            time,
            Next,
            loadLottie,
        };
    },
};
</script>

<style lang="scss" scoped>
.timer {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.4rem;
  font-weight: $font-light;
  letter-spacing: 0.3px;
  color: $gray-2;
  margin-bottom: 0;
  padding-top: 2.6rem;
  font-size: 1.2rem;
  border-top: 1px solid #ececec;
}
.payment__another {
  width: 140px;
  margin: 0;
  cursor: pointer;
  margin: 0 auto;
  font-size: 1.4rem;
  line-height: 1.4rem;
  text-align: center;
  letter-spacing: 0.3px;
  color: $primary-color;
  background: $white;
  border: none;

  &:focus {
    border: 0.1em solid currentColor;
    outline: $primary-color;
  }
  &:disabled{
    opacity: 0.4;
}
  &.otp {
    &:hover {
      text-decoration: underline;
    }
    &:disabled{
       opacity: 0.4;
    }
  }
}
.another-saved, .otp{
    margin: 2rem 0 0px; 
}
.figure {
  height: 2rem;
}
.otp-instruction{
    font-size: 1.4rem;
    margin-top: -1.8rem;
    margin-bottom: 3rem;
}
.payment__instruction--duration {
    color: red;
}
</style>